import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    footerContainer: 'p-4 space-y-3',
    savingsContainer: 'bg-grey-90 px-4 py-2 text-center',

    // TODO: to be phased out after GLOBAL15-108791 goes live
    viewCart: 'w-full'
  },
  dialogOptions: {
    type: 'panel',
    size: 'full'
  }
} satisfies RecursivePartial<DialogConfig['miniCart']>
